import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { encryptStorage } from '../../constant';
import { getAdmin, getDepartmentData, getroleName } from '../../service/adminApi';
import './leftnav.css';

function LeftNavBar() {
    const navigate = useNavigate();

    let params = useParams();
    let tabName = params['*'];

    const [departmentList, setDepartmentList] = React.useState([]);

    React.useEffect(() => {
        getDepartments();
        authorizeUser();
    }, []);

    const authorizeUser = async () => {
        let userRole = encryptStorage.getItem('role');
        if (userRole !== 'Hr Manager') {
            sessionStorage.clear();
            navigate('/');
        }
    };

    const getDepartments = async () => {
        const response = await getDepartmentData();

        setDepartmentList(response.data.data);
    };
    //p_um_01-this method gets invoked when the user clicks the user management in the account administration left nav bar in Admin Module
    const handleNavigate = (e, routeIndex) => {
        e.preventDefault();
        switch (routeIndex) {
            case 1:
                navigate('/admin/accountbranding');
                break;
            case 2:
                navigate('/admin/formatsettings');
                break;
            case 3:
                navigate('/admin/weekendandHolidays');
                break;
            case 4:
                navigate('/admin/evaluationperiod');
                break;
            case 5:
                navigate('/admin/goals');
                break;
            case 6:
                navigate('/admin/leave');
                break;
            case 7:
                navigate('/admin/recuritementmessage');
                break;
            case 8:
                navigate('/admin/recuritementofferletter');
                break;
            case 9:
                navigate('/admin/fresherquestions');
                break;
            case 10:
                navigate('/admin/experiencequestions');
                break;
            case 12:
                navigate('/admin/offboarding');
                break;
            case 13:
                navigate('/admin/announcements');
                break;
            case 14:
                navigate('/admin/teammood');
                break;
            case 15:
                navigate('/admin/category');
                break;
            case 16:
                navigate('/admin/usermanagement');
                break;
            case 17:
                navigate('/admin/departments');
                break;
            case 18:
                navigate('/admin/fresherquestionstechnical');
                break;
            case 19:
                navigate('/admin/fresherquestionsaptitude');
                break;
            case 20:
                navigate('/admin/fresherquestionsprogramming');
                break;
       

            default:
                break;
        }
    };

    const handleDepartmentNavigation = (id) => {
        navigate('/admin/experiencequestions/' + id);
    };

    const renderDepartmentData = () => {
        return departmentList.map((department, i) => {
            return (
                <li>
                    <button
                        onClick={() => {
                            handleDepartmentNavigation(department.id);
                        }}
                        className="text-start font-grey btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4 admin-custom-inner-accordian-color"
                    >
                        {department.department_name}
                    </button>
                </li>
            );
        });
    };

    return (
        <div className="col-md-2 flex-shrink-0 bg-white admin-sidenav p-0 mt-1">
            <h4 className="d-flex align-items-center ps-4 py-3 mb-3 link-dark border-bottom bold-text font-14">Account Administration</h4>
            <ul className="list-unstyled ps-0 admin-left-nav">
                <li className="mb-1 px-3">
                    <button
                        className="btn accordion-button admin-custom-accordion p-2 w-100 active text-start rounded collapsed semibold-text font-12"
                        data-bs-toggle="collapse"
                        data-bs-target="#account-settings"
                        aria-expanded="false"
                    >
                        <span className="me-2 admin-after-select">
                            <img alt="settings" className src="/Images/settings.svg" />
                        </span>
                        Account Settings
                    </button>
                    <div className="collapse " id="account-settings">
                        <ul className="btn-toggle-nav list-unstyled pb-1 small">
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 1)}
                                    className={`text-start ${
                                        tabName == 'accountbranding' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Account Branding
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 3)}
                                    className={`text-start ${
                                        tabName == 'weekendandHolidays' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Weekends &amp; Holidays
                                </button>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="mb-1 px-3">
                    <button
                        className="btn accordion-button admin-custom-accordion p-2 w-100 text-start rounded collapsed semibold-text font-12"
                        data-bs-toggle="collapse"
                        data-bs-target="#performance"
                        aria-expanded="false"
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/flag.svg" />
                        </span>
                        Performance
                    </button>
                    <div className="collapse" id="performance">
                        <ul className="btn-toggle-nav list-unstyled pb-1 small">
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 4)}
                                    className={`text-start ${
                                        tabName == 'evaluationperiod' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Evaluation Period
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 5)}
                                    className={`text-start ${
                                        tabName == 'goals' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Goals
                                </button>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="mb-1 px-3">
                    <button
                        onClick={(e) => handleNavigate(e, 6)}
                        className={`${
                            tabName == 'leave' ? `admin-text-main-color` : `btn`
                        } btn admin-custom-nav-btn p-2 w-100 text-start rounded semibold-text font-12`}
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/Leave.svg" />
                        </span>
                        Leave/WFH Settings
                    </button>
                </li>
                <li className="mb-1 px-3">
                    <button
                        className="btn accordion-button admin-custom-accordion p-2 w-100 text-start rounded collapsed semibold-text font-12"
                        data-bs-toggle="collapse"
                        data-bs-target="#recruitment-settings"
                        aria-expanded="false"
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/Recruitment.svg" />
                        </span>
                        Recruitment Settings
                    </button>
                    <div className="collapse" id="recruitment-settings">
                        <ul className="btn-toggle-nav list-unstyled pb-1 small">
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 7)}
                                    className={`text-start ${
                                        tabName == 'recuritementmessage' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Messages
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 8)}
                                    className={`text-start ${
                                        tabName == 'recuritementofferletter' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Offer Letter
                                </button>
                            </li>
                            <li className="mb-1 ps-3">
                                <button
                                    className={`btn admin-custom-nav-btn p-2 ${
                                        tabName == 'fresherquestions' ? `admin-text-color` : `font-grey`
                                    } w-100 text-start rounded semibold-text font-12`}
                                    onClick={(e) => handleNavigate(e, 9)}
                                >
                                    <span className="me-2">Questions - Preliminary</span>
                                </button>
                                <div className="collapse" id="questions-fresher"></div>
                            </li>
                            <li className="mb-1 ps-3">
                                <button
                                    className={`btn admin-custom-nav-btn p-2 ${
                                        tabName == 'fresherquestionsaptitude' ? `admin-text-color` : `font-grey`
                                    } w-100 text-start rounded semibold-text font-12`}
                                    onClick={(e) => handleNavigate(e, 19)}
                                >
                                    <span className="me-2">Questions - Aptitude Test</span>
                                </button>
                                <div className="collapse" id="questions-fresher"></div>
                            </li>
                            <li className="mb-1 ps-3">
                                <button
                                    className={`btn admin-custom-nav-btn p-2 ${
                                        tabName == 'fresherquestionstechnical' ? `admin-text-color` : `font-grey`
                                    } w-100 text-start rounded semibold-text font-12`}
                                    onClick={(e) => handleNavigate(e, 18)}
                                >
                                    <span className="me-2">Questions - Technical Skill Test</span>
                                </button>
                                <div className="collapse" id="questions-fresher"></div>
                            </li>
                            <li className="mb-1 ps-3">
                                <button
                                    className={`btn admin-custom-nav-btn p-2 ${
                                        tabName == 'fresherquestionsprogramming' ? `admin-text-color` : `font-grey`
                                    } w-100 text-start rounded semibold-text font-12`}
                                    onClick={(e) => handleNavigate(e, 20)}
                                >
                                    <span className="me-2">Questions - Coding Challenge</span>
                                </button>
                                <div className="collapse" id="questions-fresher"></div>
                            </li>
                            <li className="mb-1 ps-3">
                                <button
                                    className="btn accordion-button admin-custom-accordion p-2 text-start rounded collapsed semibold-text font-12"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#questions-experienced"
                                    aria-expanded="false"
                                    onClick={(e) => handleNavigate(e, 10)}
                                >
                                    <span className="me-2">Questions - Experienced</span>
                                </button>
                                <div className="collapse" id="questions-experienced">
                                    <ul className="btn-toggle-nav list-unstyled pb-1 small">{renderDepartmentData()}</ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="mb-1 px-3">
                    <button
                        onClick={(e) => handleNavigate(e, 12)}
                        className={`${
                            tabName == 'offboarding' ? `admin-text-main-color` : `btn`
                        } btn admin-custom-nav-btn p-2 w-100 text-start rounded semibold-text font-12`}
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/Users.svg" />
                        </span>
                        Offboarding
                    </button>
                </li>
                <li className="mb-1 px-3">
                    <button
                        onClick={(e) => handleNavigate(e, 13)}
                        className={`${
                            tabName == 'announcements' ? `admin-text-main-color` : `btn`
                        } btn admin-custom-nav-btn p-2 w-100 text-start rounded semibold-text font-12`}
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/Users.svg" />
                        </span>
                        Announcements
                    </button>
                </li>
                <li className="mb-1 px-3">
                    <button
                        className="btn accordion-button admin-custom-accordion p-2 w-100 active text-start rounded collapsed semibold-text font-12"
                        data-bs-toggle="collapse"
                        data-bs-target="#team-mood"
                        aria-expanded="false"
                    >
                        <span className="me-2 admin-after-select">
                            <img alt="settings" className src="/Images/settings.svg" />
                        </span>
                        Team Member Mood
                    </button>
                    <div className="collapse " id="team-mood">
                        <ul className="btn-toggle-nav list-unstyled pb-1 small">
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 14)}
                                    className={`text-start ${
                                        tabName == 'teammood' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Recurrence
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={(e) => handleNavigate(e, 15)}
                                    className={`text-start ${
                                        tabName == 'category' ? `admin-text-color` : `font-grey`
                                    }  btn w-100 shadow-none link-dark rounded text-decoration-none semibold-text font-12 ps-4`}
                                >
                                    Category
                                </button>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="mb-1 px-3">
                    <button
                        onClick={(e) => handleNavigate(e, 16)}
                        className={`${
                            tabName == 'usermanagement' ? `admin-text-main-color` : `btn`
                        } btn admin-custom-nav-btn p-2 w-100 text-start rounded semibold-text font-12`}
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/Users.svg" />
                        </span>
                        User Management
                    </button>
                </li>
                <li className="mb-1 px-3">
                    <button
                        onClick={(e) => handleNavigate(e, 17)}
                        className={`${
                            tabName == 'departments' ? `admin-text-main-color` : `btn`
                        } btn admin-custom-nav-btn p-2 w-100 text-start rounded semibold-text font-12`}
                    >
                        <span className="me-2">
                            <img alt="" src="/Images/Users.svg" />
                        </span>
                        Department Management
                    </button>
                </li>
              
            </ul>
        </div>
    );
}

export default LeftNavBar;
